<mat-tree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  class="lty-tree"
>
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles.
    This padding value depends on the mat-icon-button width. -->
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodeToggle
    [class.clickable]="clickable"
    [class.selected]="selectedElement?.id === node?.id"
    (click)="handleNodeClick(node, $event)"
  >
    <div class="tree-node-content root-node-content">
      <app-file-alternate-2-icon width="16px" height="16px" />
      {{ getNodeName ? getNodeName(node) : node.name }}
    </div>
    <input
      *ngIf="selectable"
      type="checkbox"
      [checked]="isNodeSelected(node)"
      (change)="toggleNodeSelection(node, $event)"
      (click)="$event.stopPropagation()"
      class="form-check-input"
    />
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChildren">
    <div
      class="mat-tree-node"
      [class.clickable]="clickable"
      [class.selected]="selectedElement?.id === node?.id"
      (click)="handleNodeClick(node, $event)"
    >
      <button
        class="toggle-button"
        mat-icon-button
        [attr.aria-label]="'Toggle ' + node.name"
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <div class="tree-node-content">
        <app-folder-icon width="16px" height="16px" />
        {{ getNodeName ? getNodeName(node) : node.name }}
      </div>
      <input
        *ngIf="selectable"
        type="checkbox"
        [checked]="isNodeSelected(node)"
        (change)="toggleNodeSelection(node, $event)"
        (click)="$event.stopPropagation()"
        class="form-check-input"
      />
    </div>
    <!-- There is inline padding applied to this div using styles.
          This padding value depends on the mat-icon-button width.  -->
    <div
      [class.lty-tree-invisible]="!treeControl.isExpanded(node)"
      class="test"
      role="group"
    >
      <ng-container matTreeNodeOutlet />
    </div>
  </mat-nested-tree-node>
</mat-tree>
